import React from 'react';
import { dresses } from "../examples.js"


const LookBook=() => {
    return(
        <div class='lookBook'>
            <h1 className='lookBookTitle'>Our Brides</h1>
            <div className='lookBookGallery'>
            {dresses.map(dress => (
                <li key={dress.key} className='lookBookListItem'>
                    <h2 className='brideName'>{dress.name}</h2>
                    {dress.dressImg?.map((dressImage, index )=> (
                    <div>
                     <img loading={dress.loading} className='lookBookImg' src={dressImage} alt={dress.alt}></img>
                     </div>
                    
                    ))}
                    
                    {/* <h2 className='brideName'>{dress.name}</h2> */}
                </li>
            ))}
            </div>
        </div>
    );
}

export default LookBook;